import React, { Component } from 'react'
import { connect } from 'react-redux'
import { uploadFileToOrder } from '../../../../actions/orders'
import { renderFullDate } from '../../../../utils/time'
import { translation } from '../../../../utils/helpers'

import { FILE_STORAGE_API, API_URL } from '../../../../constants'
// import {  } from '../../../elements/icons'

import './assessmentrpreportfiles.scss'
import Dropzone from '../../Dropzone'

// Elements
import Grid from '../../../elements/grid'
// import Icon from '../../../elements/icon'
class AssessmentRPReportFiles extends Component {

  constructor (props) {
    super(props)
    this.state = {
      selectedFile: null
    }
  }

  renderUpload () {
    const onDropAccepted = (files) => {
      let file = files[0]
      if (file.type === 'application/pdf') {
        this.props.uploadFileToOrder(file, this.props.order.Id, 12).then((res) => {
          if (!res) {
            // Toastr
            window.toastr.error(translation(15194), translation('216'))
          } else {
            // Toastr
            // window.toastr.success(translation(15193), translation('13424'))
            if (this.props.onUploadSuccess !== undefined) {
              this.props.onUploadSuccess(res)
            }
          }
        }, (err) => {
          // Toastr
          window.toastr.error(translation(15194), translation('216'))
          if (this.props.onUploadError !== undefined) {
            this.props.onUploadSuccess(err.response)
          }
        })
      } else {
        // Toastr
        window.toastr.error(translation(15194), translation('216'))
      }
    }

    return (
      <div className='browse clearfix'>
        <div className='h-line'>{translation(15192)}</div>
        <Dropzone
          // onDrop={onDrop}
          onDropAccepted={onDropAccepted}
          // onDropRejected={onDropRejected}
          includeCircles={false}>
          <p>{translation(13397)}</p>
        </Dropzone>
      </div>
    )
  }

  renderReportFile (file, key) {
    if (!file || file.FileName === null) return null
    let newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + file.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
    let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.FileName
    let fileTitle = file.FileName
    switch (file.SectionType) {
      case 1:
        fileTitle = 14836 // 'Lakrapport @'
        break
      case 2:
        fileTitle = 15199 // 'Karosserirapport @'
        break
      case 4:
        fileTitle = 14837 // 'Reservedelsrapport @'
        break
    }
    const renderDate = () => {
      return <div className='date'>{renderFullDate(this.props.order.Report.CreatedDate)}</div>
    }
    return (
      <div key={key} className='rp-report-file clearfix'>
        <a target='_BLANK' href={newFileUrl}>
          <Grid cols={['max-content', 'min-content', 1]} align='center'>
            <span>{translation(fileTitle)}</span>
            <img className='file-icon' alt='icon' src={thumbUrl} />
            {this.props.showDates && renderDate()}
          </Grid>
        </a>
      </div>
    )
  }

  render () {
    let file = this.props.attachment
    let forsiEnable = this.props.auth.permissions.ChainAssessmentSystem === 1 // Forsi is available for the company
    let hidden = this.props.editable !== true && file === null
    return (
      <div className={'rp-file-box' + (hidden ? ' hidden' : '')}>
        {forsiEnable && this.props.editable && this.renderUpload()}
        {this.renderReportFile(file)}
      </div>
    )
  }

}

AssessmentRPReportFiles.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  uploadFileToOrder
})(AssessmentRPReportFiles)



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/AssessmentRPReportFiles/index.js